// Time-window helpers for usage aggregation. All values in epoch milliseconds.

export const HOUR_MS = 3_600_000;
export const DAY_MS = 86_400_000;
export const ROLLING_5H_MS = 5 * HOUR_MS;
export const ROLLING_WEEK_MS = 7 * DAY_MS;

/** Start of the current calendar month (local time). */
export function startOfMonth(nowMs: number): number {
  const d = new Date(nowMs);
  return new Date(d.getFullYear(), d.getMonth(), 1).getTime();
}

/** Start of the local calendar day containing `ms`. */
export function startOfDay(ms: number): number {
  const d = new Date(ms);
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

/** YYYY-MM-DD key for the local day containing `ms`. */
export function dayKey(ms: number): string {
  const d = new Date(ms);
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${mm}-${dd}`;
}
